import { render } from "./TechData.vue?vue&type=template&id=aa8dbf12"
import script from "./TechData.vue?vue&type=script&lang=js"
export * from "./TechData.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__